import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CommonDatagrid } from '..';
import { UploadFastMovingSkuDialog } from '../../Dialog/FastMovingSku/UploadFastMovingSkuDialog';
import { showNotification } from '../../../store/Reducers/NotificationSnackbarSlice';
import { FastMovingSkuService } from '../../../api/services/fastMovingSkuService';
import { IFastMovingSkuVersionSummary } from '../../../types/api/response/fastmovingskuresponse';
import { getFastMovingSkuVersionsColumns } from './columns';

export const FastMovingSkuVersionsDatagrid = () => {
  const dispatch = useDispatch();
  const [versions, setVersions] = useState<IFastMovingSkuVersionSummary[]>([]);
  const [loading, setLoading] = useState(false);
  const [activatingVersion, setActivatingVersion] = useState<number | null>(null);

  const fetchVersions = async () => {
    setLoading(true);
    try {
      const result = await FastMovingSkuService.listVersions();
      setVersions(result);
    } catch (err: any) {
      dispatch(
        showNotification({
          message: `Failed to load fast-moving SKU versions. ${err?.response?.data?.message || ''}`,
          severity: 'error',
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVersions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleActivate = async (listVersion: number) => {
    setActivatingVersion(listVersion);
    try {
      await FastMovingSkuService.activateVersion(listVersion);
      dispatch(
        showNotification({
          message: `Version ${listVersion} is now active.`,
        }),
      );
      await fetchVersions();
    } catch (err: any) {
      dispatch(
        showNotification({
          message: `Failed to activate version. ${err?.response?.data?.message || ''}`,
          severity: 'error',
        }),
      );
    } finally {
      setActivatingVersion(null);
    }
  };

  return (
    <CommonDatagrid
      data={versions}
      columns={getFastMovingSkuVersionsColumns(handleActivate, activatingVersion)}
      rowId="list_version"
      loading={loading}
      headerActionButtons={<UploadFastMovingSkuDialog onUploaded={fetchVersions} />}
    />
  );
};
